import { useMutation } from '@tanstack/react-query'

import { integrationAPI } from '@/api/new-api'
import { resetQueries } from '@/utils'

import { getRemoteLockConnectionQueryKey } from './get-remote-lock-connection'

type UpdateRemoteLockConnectionRequest = {
  authorizationCode: string
  buildingId: number
  config: {
    shouldAutoAssignApartmentDoorVisitor: boolean
    staffDefaults: { id: string; name: string }[]
    visitorDefaults: { id: string; name: string }[]
  }
}

const updateRemoteLockConnection = async (data: UpdateRemoteLockConnectionRequest) => {
  const response = await integrationAPI.post('/remote-lock/connect-building', data)
  return response.data
}

export const useUpdateRemoteLockConnection = () =>
  useMutation({
    mutationFn: updateRemoteLockConnection,
    onSuccess: async (_data, variables) => {
      await resetQueries([getRemoteLockConnectionQueryKey({ buildingId: variables.buildingId })])
    },
  })
